import { mapPersonalInfoType, PersonalInfoType } from "../PersonalInfoType";
import { mapUserRoleInfoType, UserRoleInfoType } from "../UserRoleInfoType";
import {
    DateColor,
    mapDateColors,
    mapOtherExpenseDatas,
    mapProjectWiseDatas,
    mapStaffPaidDatas,
    OtherExpenseData,
    ProjectWiseData,
    StaffPaidData
} from "./AttendanceStaffView";

/* ******************************************************* Attendance staff view detail Input */
export interface AttendanceViewDetailInput {
    personal_info_id?: number | null;
    project_id?: number | null;
    year_month?: string | null;
}

export const mapAttendanceViewDetailInput = (data: any): AttendanceViewDetailInput => {
    if (!data) {
        throw new Error('Invalid Data')
    }

    const response: AttendanceViewDetailInput = {
        personal_info_id: data.personal_info_id,
        project_id: data.project_id ?? null,
        year_month: data.year_month ?? null,
    }

    return response;
}
/* ******************************************************* */


/* ******************************************************* Attendance staff view detail */
export interface AttendanceViewDetail {
    month?: string;
    month_format?: string;
    dates?: string[];
    colour_dates?: DateColor[];
    project_wise_data?: ProjectWiseData[];
    personal_info_id?: number;
    total_hours?: number;
    total_days?: number;
    total_wage?: number;
    total_paid?: number;
    cumulative?: number;
    payed_data_list?: StaffPaidData[];
    other_expense_list?: OtherExpenseData[];
    personalInfo?: PersonalInfoType | null;
    userRoleInfo?: UserRoleInfoType | null;
}

export const mapAttendanceViewDetail = (staffData: any): AttendanceViewDetail => {
    if (!staffData) {
        throw new Error('Invalid Data')
    }

    const response: AttendanceViewDetail = {
        month: staffData.month,
        month_format: staffData.month_format,
        dates: Array.isArray(staffData.dates) ? staffData.dates : [],
        colour_dates: Array.isArray(staffData.colour_dates) ? mapDateColors(staffData.colour_dates) : [],
        project_wise_data: Array.isArray(staffData.project_wise_data) ? mapProjectWiseDatas(staffData.project_wise_data) : [],
        personal_info_id: staffData.personal_info_id,
        total_hours: staffData.total_hours,
        total_days: staffData.total_days,
        total_wage: staffData.total_wage,
        total_paid: staffData.total_paid,
        cumulative: staffData.cumulative,
        payed_data_list: Array.isArray(staffData.payed_data_list) ? mapStaffPaidDatas(staffData.payed_data_list) : [],
        other_expense_list: Array.isArray(staffData.other_expense_list) ? mapOtherExpenseDatas(staffData.other_expense_list) : [],
        personalInfo: staffData.personalInfo !== null ? mapPersonalInfoType(staffData.personalInfo) : null,
        userRoleInfo: staffData.userRoleInfo !== null ? mapUserRoleInfoType(staffData.userRoleInfo) : null
    }

    return response;
}

export const mapAttendanceViewDetails = (data: any[]): AttendanceViewDetail[] => {
    if (!Array.isArray(data)) {
        throw new Error('Invalid Data');
    }

    return data.map(mapAttendanceViewDetail);
}
/* ******************************************************* */